import React, { useRef } from 'react';
import { Camera, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

const MAX_BYTES = 900_000;

/** Photo preview + file picker → data URL for staff profiles. */
export default function ProfilePhotoField({ photoUrl, onChange }) {
  const inputRef = useRef(null);

  const onFile = (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    if (!file.type.startsWith('image/')) {
      toast.error('Choose an image file (JPG or PNG)');
      return;
    }
    if (file.size > MAX_BYTES) {
      toast.error('Image must be under ~900 KB');
      return;
    }
    const reader = new FileReader();
    reader.onload = () => onChange(String(reader.result || ''));
    reader.readAsDataURL(file);
  };

  return (
    <div className="flex items-center gap-4" data-testid="profile-photo-field">
      <div className="h-20 w-20 rounded-full overflow-hidden bg-[#E8EEF5] border border-[#9AADBE]/40 flex items-center justify-center shrink-0">
        {photoUrl ? (
          <img src={photoUrl} alt="" className="h-full w-full object-cover" />
        ) : (
          <Camera className="h-7 w-7 text-[#9AADBE]" />
        )}
      </div>
      <div className="space-y-2">
        <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={onFile} />
        <Button type="button" size="sm" variant="outline" onClick={() => inputRef.current?.click()}>
          Upload photo
        </Button>
        {photoUrl ? (
          <Button type="button" size="sm" variant="ghost" className="text-red-600" onClick={() => onChange('')}>
            <Trash2 className="h-3.5 w-3.5 mr-1" /> Remove
          </Button>
        ) : null}
        <p className="text-[11px] text-zinc-500">Optional. JPG/PNG under 900 KB.</p>
      </div>
    </div>
  );
}
